/**
 * Safe redirect targets for post-login / post-register flows.
 * Rejects open redirects (e.g. //evil.com) and non-path values.
 */

import { CONTROL_BRIDGE_HOME_PATH } from './controlBridgeRoutes';

/** Default destination after signup (company name already collected on register). */
export const POST_REGISTER_PATH = '/onboarding/prospector';

export function normalizeNextPath(
  raw: string | null,
  defaultPath: string = CONTROL_BRIDGE_HOME_PATH
): string {
  if (!raw || !raw.startsWith('/')) return defaultPath;
  if (raw.startsWith('//')) return defaultPath;
  const pathOnly = raw.split('?')[0];
  if (pathOnly === '/dashboard' || pathOnly === '/dashboard/') {
    return CONTROL_BRIDGE_HOME_PATH;
  }
  return pathOnly || defaultPath;
}

/** Build `/login` query string with optional next + registered flag. */
export function loginHrefWithNext(next: string | null, options?: { registered?: boolean }): string {
  const q = new URLSearchParams();
  const explicitNext = next && next.startsWith('/') && !next.startsWith('//') ? next : null;
  const effectiveNext = explicitNext ?? (options?.registered ? POST_REGISTER_PATH : null);
  if (effectiveNext) {
    const pathOnly = effectiveNext.split('?')[0];
    q.set('next', pathOnly || POST_REGISTER_PATH);
  }
  if (options?.registered) {
    q.set('registered', '1');
  }
  const s = q.toString();
  return s ? `/login?${s}` : '/login';
}

/** Build `/register?next=…` defaulting to prospector for new-user intake. */
export function registerHrefWithNext(next: string | null = null): string {
  const safe = normalizeNextPath(next, POST_REGISTER_PATH);
  return `/register?next=${encodeURIComponent(safe)}`;
}
